import { ui } from 'modules/common';
import { DefaultPageLayout } from 'modules/page';
import { memo } from 'react';
import Skeleton from 'react-loading-skeleton';
import styled from 'styled-components';

export const Card = styled(ui.Card)`
    padding: 10px 0;
    min-height: 80vh;
`;

export const Toolbar = styled.div`
    padding: 25px 60px 30px 60px;
    border-bottom: 1px solid #cacccd;
`;

export const Header = styled.div`
    display: flex;
    align-items: center;
`;

export const Fields = styled.div`
    display: flex;
    align-items: center;
    margin-top: 40px;
`;

export const Content = styled.div`
    padding: 30px 60px;
`;

export const LoadingOld = memo(() => {
    return (
        <DefaultPageLayout documentTitle='Request'>
            <Card>
                <Toolbar>
                    <Header>
                        <div style={{ marginRight: 'auto' }}>
                            <Skeleton width={130} height={22} />
                        </div>

                        <Skeleton width={50} height={36} />

                        <div style={{ marginLeft: '10px' }}>
                            <Skeleton width={50} height={36} />
                        </div>

                        <div style={{ marginLeft: '10px' }}>
                            <Skeleton width={215} height={36} />
                        </div>
                    </Header>

                    <Fields>
                        <div style={{ flex: 3, marginRight: '20px' }}>
                            <Skeleton height={26} />
                        </div>

                        <div style={{ flex: 1, marginRight: '20px' }}>
                            <Skeleton height={26} />
                        </div>

                        <div style={{ flex: 1, marginRight: '20px' }}>
                            <Skeleton height={26} />
                        </div>

                        <div style={{ flex: 1 }}>
                            <Skeleton height={26} />
                        </div>
                    </Fields>
                </Toolbar>

                <Content>
                    <div>
                        <Skeleton width={180} height={25} />
                    </div>

                    <div style={{ marginTop: 25 }}>
                        <Skeleton width={170} height={25} />
                    </div>

                    <div style={{ marginTop: 10 }}>
                        <Skeleton height={90} />
                    </div>

                    <div style={{ marginTop: 40 }}>
                        <div style={{ display: 'flex' }}>
                            <div style={{ marginRight: 'auto' }}>
                                <Skeleton height={25} width={90} />
                            </div>

                            <Skeleton height={25} width={400} />
                        </div>

                        <div style={{ marginTop: 10 }}>
                            <Skeleton height={110} />
                        </div>

                        <div style={{ marginTop: 20 }}>
                            <Skeleton height={20} width={140} />
                        </div>
                    </div>

                    <div style={{ display: 'flex', marginTop: 50 }}>
                        <div style={{ marginLeft: 'auto', width: 350, display: 'flex', flexDirection: 'column' }}>
                            <div style={{ marginLeft: 'auto' }}>
                                <Skeleton height={12} width={145} />
                            </div>

                            <div style={{ height: '1px', background: '#979797', width: 350, margin: '5px 0' }} />

                            <div style={{ marginLeft: 'auto' }}>
                                <Skeleton height={12} width={135} />
                            </div>
                        </div>
                    </div>
                </Content>
            </Card>
        </DefaultPageLayout>
    );
});

LoadingOld.displayName = 'LoadingOld';
